module.exports = __webpack_public_path__ + "static/media/14_portrait.087c3ccc.jpg";